import styled from 'styled-components';

export const MoreWrapper = styled.div`
  font-size:0.75em;
  float:right;
  color: #4080E2;
  cursor: pointer;
  &:hover {
    color: #0945A2;
  }
`;

export const ExtraWrapper = styled.div`
  font-size: 0.75em;
`;
